export const ArrowGreen = ({ width = 16, height = 16, color = "#86BA3E" }) => (
    <div
        style={{
            padding: "2px",
            width,
            height,
        }}
    >
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 10L8 5L12 10H4Z"
                fill={color}
            />
        </svg>
    </div>
);
